import { ResponsibleGamingTypeEnum } from '@/enums'
import { PlayerCardState } from '../models'

export const initialState: PlayerCardState = {
  isLoading: false,
  isLoadingSearch: false,
  playerCard: null,
  players: [],
  paginationSearch: {
    total: 0,
    limit: 25,
    page: 1,
    pages: 1,
  },
  wallet: null,
  countriesList: [],
  isLoadingResponsibleGaming: false,
  filtersExclusion: {
    limit: 25,
    page: 1,
    exclusionType: ResponsibleGamingTypeEnum.SELF_EXCLUSION,
    playerId: '',
  },
  responsibleGamingExclusion: {
    exlusionData: null,
    pagination: { total: 0, limit: 25, page: 1, pages: 1 },
  },
  filtersCoolOff: {
    limit: 25,
    page: 1,
    exclusionType: ResponsibleGamingTypeEnum.COOL_OFF,
    playerId: '',
  },
  responsibleGamingCoolOff: {
    exlusionData: null,
    pagination: { total: 0, limit: 25, page: 1, pages: 1 },
  },
}
